/**
 * What the staff registry lists share about living in the address.
 *
 * The companies list (#427) and the groups list (#440) keep their view in the
 * query string -- the column filters, the sort, and the page as `?pagina=`,
 * 1-based, each left out at its default -- and debounce the filter row by the
 * same pause, so the two screens type and page the same way.
 */

/** How long typing in a filter has to pause before it goes out. */
export const SEARCH_DEBOUNCE_MS = 300;

/** `?pagina=` as a page number: anything that is not a positive integer is the first. */
export function pageFrom(value: string | null): number {
  const page = Number(value);
  return Number.isInteger(page) && page >= 1 ? page : 1;
}
